import { render, staticRenderFns } from "./TabCompanies.vue?vue&type=template&id=33275d0d&scoped=true"
import script from "./TabCompanies.vue?vue&type=script&lang=js"
export * from "./TabCompanies.vue?vue&type=script&lang=js"
import style0 from "./TabCompanies.vue?vue&type=style&index=0&id=33275d0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33275d0d",
  null
  
)

export default component.exports